module.exports = __webpack_public_path__ + "img/2recr_aziende.61cc3036.png";